/**
 * Created by renlaydel on 20/11/2017.
 */

import { combineReducers } from 'redux';
import PurchaseReceiptReducer from './purchase/reducer_purchase_receipt';
import PurchaseOrderReducer from './purchase/reducer_purchase_order';
import InventoryReturnReducer from './purchase/reducer_inventory_return';



export const purchaseReducer = combineReducers( {
  'receipt': PurchaseReceiptReducer,
  'order'  : PurchaseOrderReducer,
  'return' : InventoryReturnReducer
} );